import LazyLoader from '../../utils/lazy-loader.js';
import Animate from '../helpers/animate.js';

export default class SecondaryLink {
    constructor(parent, el){
        this.parent = parent;
        this.el = el;
        this.container = el.parentElement;
        this.container.addEventListener('keydown', (event) => this.containerOnKeydown(event));
        this.bind();
        this.checkLazyContent();
    }

    items() {
        return [...this.container.querySelectorAll(':scope > ul > li')];
    }

    checkLazyContent() {
        const self = this;
        if (self.el.dataset.expand === 'desktop') {
            const lazyContainer = self.container.querySelector('.lazy-load-container');
            if(lazyContainer) {
                const finalCallBack = function(e) {
                    lazyContainer.classList.add('lazy-loaded')
                    self.el.removeEventListener('click', clickHandler);
                }

                const lazyLoader = new LazyLoader(lazyContainer, 1, finalCallBack);

                const clickHandler = function(e) {
                    lazyLoader.load();
                }

                self.el.addEventListener('click', clickHandler);
            }
        }
    }

    bind(){
        if(this.items()){ this.el.addEventListener('click', (e) => this.toggle(e)); }
    }

    toggle(e){
        if ( window.innerWidth <= 1024 || this.el.dataset.expand === "desktop" ) {
            e.preventDefault();
            this.container.classList.contains('expand--secondary') ? this.close() : this.open();
        }
    }

    containerOnKeydown(event) {
        // We handle it on small screens where the navigation is toggled via the burger menu. Most mobiles won’t have an Escape key.
        if (window.innerWidth <= 1024 && event && event.key === 'Escape') {
            event.stopPropagation();
            this.close();
            this.el.focus();
        }
    }

    close(){
        this.container.classList.remove('expand--secondary');
        this.container.querySelectorAll('.expand--tertiary > li').forEach((el) => el.classList.remove('items--expanded'));
    }

    closeOthers(){
        [...this.parent.flyout.querySelectorAll('.expand--secondary')].filter((s) => !s.contains(this.el)).forEach((s) => s.classList.remove('expand--secondary'));
        [...this.parent.flyout.querySelectorAll('.expand--tertiary > li')].forEach((s) => s.classList.remove('items--expanded'));
    }

    open(){
        this.closeOthers();
        this.container.classList.add('expand--secondary');
        Animate.addClass(this.items(), 'items--expanded', 50)
            .then(() => this.parent.resize());
        Animate.scroll(this.el)
    }
}
